import { cn } from '@/lib/utils';
import { Box, type BoxProps } from './Box';

export function Overlay({ className, style, ...props }: BoxProps) {
  return (
    <Box
      position="absolute"
      inset="0"
      className={cn(className)}
      style={{ background: 'var(--gradient-card-scrim)', ...style }}
      {...props}
    />
  );
}

export type { BoxProps as OverlayProps };
